import { FooterVariant1 } from '@workspace/shared/components/FooterVariant1';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import MirLogo from '~/assets/img/dubaiexpress/mir-logo.svg';
import SbpLogo from '~/assets/img/dubaiexpress/sbp-logo.svg';
import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';

const FooterDE = () => {
  const { t } = useTranslation();

  const supportUrl = company.config.links.tg;

  return (
    <FooterVariant1
      logo={{
        src: company.images.logo.dark,
        to: '/',
      }}
      menuColumns={[
        {
          title: t('company'),
          mobileGroup: 'row1',
          items: [
            { dataLink: 'footer-about', to: '/about', label: t('aboutUs') },
            {
              dataLink: 'footer-contacts',
              to: '/contacts',
              label: t('contacts'),
            },
          ],
        },
        {
          title: t('forCustomers'),
          mobileGroup: 'row1',
          items: [
            { dataLink: 'footer-faq', to: '/faq', label: t('faq') },
            {
              dataLink: 'footer-delivery',
              to: '/delivery',
              label: t('delivery'),
            },
            {
              dataLink: 'footer-returns',
              to: '/returns',
              label: t('returnAndExchange'),
            },
          ],
        },
        {
          title: t('information'),
          items: [
            {
              dataLink: 'footer-privacy',
              to: '/legals#privacy-policy',
              label: t('privacyPolicy'),
            },
            {
              dataLink: 'footer-terms',
              to: '/legals#terms-of-service',
              label: t('userAgreement'),
            },
          ],
        },
      ]}
      paymentLogos={company.match({
        dubaiexpress: [
          { src: SbpLogo, alt: 'СБП', width: 93, height: 36 },
          { src: MirLogo, alt: 'МИР', width: 59, height: 34 },
        ],
        default: [],
      })}
      copyrightText={t('dubaiExpressCopyright')}
      supportButton={
        supportUrl
          ? {
              href: supportUrl,
              label: t('support'),
              icon: <Icon type="message_text_circle" />,
              className: 'text-white! hover:text-white!',
            }
          : undefined
      }
      linkComponent={Link}
      dataTheme={company.name}
    />
  );
};

export default FooterDE;
